// extracted by mini-css-extract-plugin
var _1 = "NotificationContainer-modulenotificationsBox__N8AGP";
export { _1 as "notificationsBox" }
